<template>
  <div class="search" @touchmove.prevent @mousewheel.prevent>
    <!-- 输入框 -->
    <div class="searchBox">
      <div class="content">
        <h3>搜索</h3>
        <div class="input">
          <van-search clearable @clear='clear()' v-model="value" placeholder="请输入选手编号或名称" />
        </div>
        <div class="searchBtn">
          <van-button @click="gotoVote()" type="primary">搜索</van-button>
        </div>
      </div>
    </div>
    <!-- 关闭按钮 -->
    <div class="close" >
      <van-icon @click='close()' name="close"  />
    </div>
  </div>
</template>

<script>
  import searchMixin from "@/mixins/search.js"
  export default {
    mixins:[searchMixin],
  }
</script>

<style lang="less" scoped>
.search{
  width: 10rem;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.5);
  .searchBox{
    width: 9.2rem;
    height: 4.0666667rem;
    box-sizing: border-box;
    position: relative;
    .content{
      width: 96%;
      height: 100%;
      position: absolute;
      padding-top: 1.2rem;
      top: -1.2333333rem;
      left: 0;
      right: 0;
      margin: auto;
      border-radius: 0.08rem;
      background: #fff8e8;
      box-shadow: 9px 12px 0 -3px #C23402, -9px 12px 0 -3px #c23402;
      &::after{
        position: absolute;
        top: 0;
        left: .21333rem;
        content: "";
        background: url('@/assets/pinkpolitics/title1.png') no-repeat;
        background-size: 100% 100%;
        width: .45333rem;
        height: .93333rem;
      }
      h3{
        font-size: 0px;
        &::after{
          position: absolute;
          width: .89867rem;
          height: .44267rem;
          content: "";
          background: url('@/assets/pinkpolitics/11234.png') no-repeat;
          background-size: 100% 100%;
          top: 0.4rem;
          left: 50%;
          transform: translateX(-50%) translateY(50%);
        }
        &::before{
          position: absolute;
          content: "";
          width:6.83467rem;
          height: 0.4rem;
          background: url('@/assets/pinkpolitics/titleOrnament.c4372660.png') no-repeat;
          background-size: 100% 100%;
          top: 0.4rem;
          left: 50%;
          transform: translateX(-50%) translateY(50%);
        }
      }
      .input{
        margin: .8rem 0 .8rem;
        .van-search{
          background: #fdeeda;
          padding: 0;
          margin: 0 .2666667rem;
          .van-search__content{
            background: transparent;
            ::placeholder{
              color: #76442e;
            }
          }
        }
      }
      .searchBtn{
        box-sizing: border-box;
        margin-left: 50%;
        transform: translateX(-50%);
        .van-button{
          width: 4.42667rem;
          height: 1.2rem;
          box-sizing: border-box;
          font-size: 16px;
          background: url('@/assets/pinkpolitics/button-twoLine.cd85c14d.png') no-repeat;
          background-size: 100% 100%;
          color: #fff;
          border: 0;
        }
      }
    }
  }
  div.close{
    margin-top: 1.2rem;
    .van-icon-close{
      font-size: .96rem;
      color: #fff;
    }
  }
}
</style>